/**
 * TabNav — top-level tab bar.
 *
 * Uses feathers Tabs with the "underlined" variant and Carbon icons.
 * Write / Check / Review tabs plus a right-aligned Manage gear icon.
 */

import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@e14c/feathers';
import { Security, TaskApproved, Edit, Settings, Pen } from '@e14c/feathers/icons';

export type ActiveTab = 'factcheck' | 'review' | 'manage' | 'writing' | 'critic';

interface TabNavProps {
  activeTab: ActiveTab;
  onTabChange: (tab: ActiveTab) => void;
}

export const TabNav: React.FC<TabNavProps> = ({ activeTab, onTabChange }) => (
  <div className="flex items-stretch shrink-0 border-b border-border bg-background">
    <Tabs
      variant="underlined"
      className="flex-1 min-w-0"
      value={activeTab === 'manage' ? '' : activeTab}
      onValueChange={(v) => onTabChange(v as ActiveTab)}
    >
      <TabsList className="px-1 w-full">
        <TabsTrigger value="writing" className="flex-1">
          <Edit size={16} />
          Write
        </TabsTrigger>
        <TabsTrigger value="factcheck" className="flex-1">
          <Security size={16} />
          Check
        </TabsTrigger>
        <TabsTrigger value="review" className="flex-1">
          <TaskApproved size={16} />
          Review
        </TabsTrigger>
        <TabsTrigger value="critic" className="flex-1">
          <Pen size={16} />
          Critic
        </TabsTrigger>
      </TabsList>
    </Tabs>
    <button
      type="button"
      aria-label="Manage"
      aria-pressed={activeTab === 'manage'}
      onClick={() => onTabChange('manage')}
      className={`shrink-0 self-center mr-2 rounded p-1.5 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground ${
        activeTab === 'manage' ? 'bg-muted text-foreground' : ''
      }`}
    >
      <Settings size={16} />
    </button>
  </div>
);
